<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/T5kWON/tc-custom/9780897338271.jpg?1700958272320" alt="This image is the cover for the book Looking Backward"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Looking Backward
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Essays chronicling the Jewish history of Chicago, from the late nineteenth century to the end of World War II.</b></p><p> The history of Jews in Chicago is a fascinating, complex, and largely unknown story. Thanks to the unstinting efforts of Walter Roth, much of this history has been preserved. Now, for the first time, this material has been distilled into a single volume, chronicling events and people from the late nineteenth century to the end of World War II. </p><p> There are six broad themes, each of which includes several essays: the first of which is “Chicago Jews and the Secular City: Builders, Movers, Shakers” about HL Mettes’s huge 1924 history of Chicago Jews; financier Lazarus Silverman; the U of C Centennial; Jewish participation in the World’s Columbian Exposition; Julius Rosenwald and the Museum of Science &amp; Industry and the Jewish Day Pageant at the Century of Progress in 1933. </p><p> The other five themes are “Chicago Jews and Anti-Semitism: Tragedy Abroad, Challenges at Home”; “Chicago Jews and Zionism: Local Idealists”; “Chicago Jews and Zionism: Renowned Visitors”; “Chicago Jews and the Arts: The Page and the Stage” and “Chicago Jews on Both Sides of the Law: Colorful Characters.” </p><p> Anyone interested in Chicago history, ethnic history, Jewish history, will find <i>Looking Backward</i> a fascinating and informative read. </p><p><b>Praise for <i>Looking Backward</i></b></p><b>“Roth writes about the well known and the not so well known, bringing to life the people, events, and institutions that shaped the Jewish community.” —<i>Booklist</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Walter Roth
      </h2>
      
      <p class="authorDescription body article">Walter Roth is a prominent local attorney and co-author of An Accidental Anarchist, also available from Academy Chicago Publishers.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Chicago Review Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c2b8dbaa